var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.63822 15.363C1.77863 14.5328 1.09299 13.5397 0.621306 12.4416C0.149625 11.3436 -0.0986508 10.1626 -0.109035 8.96761C-0.11942 7.77259 0.108296 6.58748 0.560824 5.48141C1.01335 4.37534 1.68163 3.37048 2.52666 2.52544C3.3717 1.68041 4.37657 1.01213 5.48263 0.559603C6.5887 0.107075 7.77382 -0.12064 8.96883 -0.110256C10.1638 -0.0998715 11.3448 0.148405 12.4429 0.620085C13.5409 1.09177 14.534 1.77741 15.3642 2.637C17.0036 4.33442 17.9108 6.60784 17.8903 8.96761C17.8698 11.3274 16.9233 13.5847 15.2546 15.2534C13.5859 16.922 11.3286 17.8686 8.96883 17.8891C6.60906 17.9096 4.33564 17.0024 2.63822 15.363ZM8.10122 4.5V9.9H9.90122V4.5H8.10122ZM8.10122 11.7V13.5H9.90122V11.7H8.10122Z",
    fill: "url(#paint0_linear_5131_13478)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5131_13478",
    x1: -0.109375,
    y1: -0.110596,
    x2: 18.2576,
    y2: 0.272009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE594"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.a92e81d8c31d0d02a816b3d6c8b8e4f4.svg";
export { ForwardRef as ReactComponent };